<template>
	<article class="list-item">
		<div class="row separated centering">
			<div class="field inline row">
				<span class="label centered rigid">
					<slot name="setting-label"></slot>
				</span>
				<span class="row">
					<div class="display-text centered rigid">
						<slot name="setting-value"></slot>
					</div>
				</span>
			</div>
			<span class="gap"></span>
			<!--footer element as slot-->
			<slot name="setting-links"></slot>
		</div>
	</article>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'SettingLink'
};
</script>



// WEBPACK FOOTER //
// ./src/components/SettingLink.vue